import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTWCL_Documentation,
  TXTWCL_Enter_document_details,
  TXTWCL_We_will_need_a_copy_of_your_ch_ELL
} from './RMFDocumentation.messages.json';
import DocumentNumberField from './components/DocumentNumberField/DocumentNumberField';
import DocumentTypeField from './components/DocumentTypeField/DocumentTypeField';
import ExpiryDateField from './components/ExpiryDateField/ExpiryDateField';
import IssueDateField from './components/IssueDateField/IssueDateField';
import IssuingAuthorityField from './components/IssuingAuthorityField/IssuingAuthorityField';
import PlaceOfIssueField from './components/PlaceOfIssueField/PlaceOfIssueField';

const RMFDocumentation: React.FunctionComponent = () => (
  <Container
    page={RMFDocumentation}
    headerProps={{
      title: <Translation {...TXTWCL_Documentation} />
    }}
    pageTopTitle={<Translation {...TXTWCL_Enter_document_details} />}
    pageTopSubtitle={<Translation {...TXTWCL_We_will_need_a_copy_of_your_ch_ELL} />}
  >
    <fieldset>
      <DocumentTypeField />
      <DocumentNumberField />
      <IssueDateField />
      <ExpiryDateField />
      <PlaceOfIssueField />
      <IssuingAuthorityField />
    </fieldset>
    <CTAButton />
  </Container>
);

RMFDocumentation.displayName = 'RMFDocumentation';

export default RMFDocumentation;
